import clsx from 'clsx';
import { m, LazyMotion, domAnimation } from 'framer-motion';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDebounce } from 'react-use';

import Content from 'components/shared/content/content';

const CollapsibleContent = ({ title, description, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [debouncedValue, setDebouncedValue] = useState('');

  useDebounce(
    () => {
      setDebouncedValue(isExpanded);
    },
    300,
    [isExpanded]
  );

  return (
    <section className={clsx('safe-paddings', className)}>
      <LazyMotion features={domAnimation}>
        <div className="list-none overflow-hidden py-5">
          <button
            className="flex w-full flex-row items-center justify-start space-x-2.5 outline-none transition-colors duration-200 hover:text-primary-2"
            type="button"
            tabIndex="0"
            onClick={() => setIsExpanded((prev) => !prev)}
            onKeyDown={() => setIsExpanded((prev) => !prev)}
          >
            <span className="flex-1 text-left text-[32px] font-bold xl:text-3xl">{title}</span>
            <span className="relative h-0.5 w-3.5 flex-shrink-0 bg-black">
              <m.span
                className="absolute -top-1.5 left-1.5 h-3.5 w-0.5 bg-black"
                initial={{ rotate: 0 }}
                animate={debouncedValue ? { rotate: 90 } : { rotate: 0 }}
                transition={{ duration: 0.3 }}
              />
            </span>
          </button>
          <m.div
            className="max-w-[936px] overflow-hidden"
            initial={{ height: 0 }}
            animate={debouncedValue ? { height: 'auto' } : { height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Content className="mt-5" content={description} asHTML />
          </m.div>
        </div>
      </LazyMotion>
    </section>
  );
};

CollapsibleContent.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  className: PropTypes.string,
};

CollapsibleContent.defaultProps = {
  description: null,
  className: null,
};

export default CollapsibleContent;
